export default __webpack_public_path__ + "static/media/shield-check.4242f7fb.svg";